<template>
    <div class="wrapper">
      <div class="login-box">
        <div class="logo-container">
          <svg width="127" height="28" viewBox="0 0 127 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_1390)">
              <path d="M36.7706 21.5721L30.8218 8.47681H33.184L36.7719 16.6544L40.3776 8.47681H42.7398L36.7706 21.5721Z"
                fill="#3F3F3E" />
              <path d="M44.3726 21.0314V8.47681H46.5923V21.0314H44.3726Z" fill="#3F3F3E" />
              <path
                d="M49.2396 21.0314V8.47681H53.6621C55.7043 8.47681 57.3024 9.05307 58.4403 10.2241C59.0216 10.8222 59.4747 11.5358 59.7712 12.32C60.0677 13.1042 60.2012 13.9421 60.1632 14.7811C60.2018 15.6159 60.0703 16.4498 59.7769 17.2307C59.4835 18.0117 59.0345 18.7229 58.458 19.3201C57.3211 20.4551 55.7229 21.0309 53.6799 21.0309L49.2396 21.0314ZM51.4593 18.996H53.5196C56.5926 18.996 57.9422 17.3567 57.9422 14.7811C57.9422 12.1334 56.6104 10.5122 53.5028 10.5122H51.4606L51.4593 18.996Z"
                fill="#3F3F3E" />
              <path
                d="M62.0808 21.0314V8.47681H69.9669V10.5122H64.3009V13.502H69.6118V15.5374H64.3009V18.996H70.0912V21.0314H62.0808Z"
                fill="#3F3F3E" />
              <path
                d="M73.4127 19.4101C72.7962 18.8148 72.3087 18.0957 71.9815 17.2986C71.6543 16.5016 71.4944 15.6442 71.5122 14.781C71.4944 13.9179 71.6543 13.0604 71.9815 12.2634C72.3087 11.4664 72.7962 10.7473 73.4127 10.152C74.0191 9.5352 74.7426 9.04959 75.5394 8.72458C76.3361 8.39956 77.1897 8.24189 78.0483 8.2611C78.907 8.24183 79.7606 8.39948 80.5575 8.7245C81.3544 9.04951 82.078 9.53515 82.6844 10.152C83.3067 10.7438 83.7991 11.4618 84.1296 12.2594C84.4601 13.0569 84.6213 13.9161 84.6027 14.781C84.6204 15.6442 84.4606 16.5016 84.1334 17.2986C83.8061 18.0957 83.3187 18.8148 82.7022 19.4101C82.0888 20.0213 81.3611 20.5019 80.5619 20.8236C79.7627 21.1453 78.908 21.3017 78.0483 21.2834C77.1914 21.3016 76.3395 21.1451 75.5433 20.8233C74.747 20.5015 74.0225 20.021 73.4127 19.4101ZM74.9403 17.9694C75.3455 18.3854 75.83 18.7134 76.3643 18.9333C76.8986 19.1532 77.4714 19.2604 78.0479 19.2485C78.6219 19.2604 79.1922 19.1531 79.7237 18.9331C80.2553 18.7132 80.7368 18.3852 81.1386 17.9694C81.5494 17.5512 81.8727 17.0534 82.0894 16.5055C82.306 15.9577 82.4114 15.3712 82.3994 14.781C82.4114 14.1909 82.306 13.6044 82.0894 13.0566C81.8727 12.5087 81.5494 12.0108 81.1386 11.5926C80.7402 11.171 80.2597 10.838 79.7276 10.6147C79.1956 10.3914 78.6236 10.2828 78.0479 10.2956C77.4697 10.2828 76.8952 10.3914 76.3604 10.6146C75.8256 10.8379 75.3421 11.1708 74.9403 11.5926C74.532 12.0118 74.2115 12.5103 73.9979 13.0582C73.7843 13.6061 73.682 14.1921 73.6973 14.781C73.6787 15.3704 73.7794 15.9574 73.9932 16.5058C74.207 17.0541 74.5293 17.5523 74.9403 17.9694Z"
                fill="#3F3F3E" />
              <path d="M89.3094 21.0313V9.34118H85.7214V8.47632H93.8385V9.34118H90.2327V21.0313H89.3094Z"
                fill="#003FDB" />
              <path
                d="M95.9698 21.0314V8.47681H102.718V9.34164H96.8919V13.9527H102.38V14.8351H96.8919V20.167H102.841V21.0314H95.9698Z"
                fill="#003FDB" />
              <path
                d="M114.957 9.57747V10.6764C114.438 10.1724 113.825 9.77757 113.155 9.51485C112.484 9.25213 111.769 9.12665 111.051 9.1457C110.323 9.12611 109.599 9.25831 108.924 9.53409C108.249 9.80986 107.636 10.2234 107.125 10.7489C106.609 11.2754 106.204 11.9032 105.935 12.5939C105.666 13.2845 105.54 14.0235 105.562 14.7657C105.54 15.5078 105.666 16.2469 105.935 16.9375C106.204 17.6282 106.609 18.256 107.125 18.7825C107.636 19.3081 108.249 19.7215 108.924 19.9973C109.599 20.2731 110.323 20.4053 111.051 20.3857C111.769 20.4047 112.484 20.2793 113.155 20.0165C113.825 19.7538 114.438 19.359 114.957 18.855V19.9354C113.85 20.8302 112.465 21.2963 111.051 21.2501C110.206 21.2691 109.365 21.1142 108.581 20.7948C107.797 20.4755 107.084 19.9983 106.487 19.3921C105.883 18.7898 105.407 18.0682 105.089 17.2719C104.772 16.4757 104.619 15.6217 104.64 14.763C104.619 13.9043 104.772 13.0503 105.089 12.254C105.407 11.4578 105.883 10.7362 106.487 10.1339C107.084 9.5255 107.796 9.04588 108.58 8.72393C109.365 8.40199 110.205 8.24437 111.051 8.26059C112.466 8.21523 113.851 8.68207 114.957 9.57747Z"
                fill="#003FDB" />
              <path
                d="M121.654 8.13452L127 21.0317H126.059L124.638 17.6101H118.67L117.25 21.0317H116.308L121.654 8.13452ZM119.043 16.7444H124.265L121.655 10.368L119.043 16.7444Z"
                fill="#003FDB" />
              <path
                d="M7.32234 27.9986C5.38102 27.9964 3.51985 27.2133 2.14713 25.8212C0.77441 24.4291 0.00223242 22.5417 0 20.5729V8.0953C0.0025848 6.12679 0.774916 4.23969 2.1476 2.84787C3.52028 1.45605 5.38125 0.673162 7.32234 0.670898C8.59261 0.673543 9.84037 1.01115 10.9431 1.65057L21.7308 7.8891C22.8514 8.53892 23.783 9.47727 24.4314 10.6092C25.0798 11.7412 25.422 13.0266 25.4235 14.3357C25.422 15.6447 25.0798 16.9301 24.4315 18.0621C23.7832 19.194 22.8517 20.1323 21.7313 20.7822L10.9436 27.0208C9.84059 27.6599 8.59263 27.9968 7.32234 27.9986ZM7.32234 1.22377C5.52589 1.22579 3.80358 1.95039 2.5333 3.23861C1.26301 4.52684 0.548488 6.27347 0.546491 8.0953V20.5729C0.548605 22.3946 1.2631 24.1411 2.53327 25.4293C3.80343 26.7175 5.52556 27.4422 7.3219 27.4444C8.49721 27.4421 9.65169 27.1296 10.6719 26.5377L21.4596 20.2992C22.4967 19.6981 23.3589 18.8299 23.9592 17.7826C24.5594 16.7352 24.8763 15.5457 24.8779 14.3343C24.8764 13.1229 24.5594 11.9334 23.9592 10.886C23.359 9.83866 22.4967 8.97055 21.4596 8.36948L10.6719 2.13095C9.65172 1.5395 8.49742 1.2273 7.32234 1.22509V1.22377Z"
                fill="url(#paint0_linear_1_1390)" />
              <path
                d="M19.6839 11.5279L8.89622 5.28926C8.41143 5.00888 7.86254 4.86252 7.30445 4.86477C6.74637 4.86702 6.19865 5.01784 5.71607 5.30212C5.23349 5.58641 4.83297 5.99417 4.55457 6.48469C4.27617 6.97521 4.12964 7.53128 4.12964 8.09725V20.5744C4.12964 21.1403 4.27617 21.6964 4.55457 22.1869C4.83297 22.6775 5.23349 23.0852 5.71607 23.3695C6.19865 23.6538 6.74637 23.8046 7.30445 23.8069C7.86254 23.8091 8.41143 23.6627 8.89622 23.3823L19.6839 17.1438C20.1725 16.8612 20.5786 16.4526 20.8611 15.9595C21.1435 15.4663 21.2923 14.9061 21.2923 14.3358C21.2923 13.7655 21.1435 13.2053 20.8611 12.7122C20.5786 12.219 20.1725 11.8104 19.6839 11.5279Z"
                fill="url(#paint1_linear_1_1390)" />
            </g>
            <defs>
              <linearGradient id="paint0_linear_1_1390" x1="14.2372" y1="30.6221" x2="11.043" y2="6.79437"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#003FDB" />
                <stop offset="1" stop-color="#00BCDB" />
              </linearGradient>
              <linearGradient id="paint1_linear_1_1390" x1="14.2213" y1="30.626" x2="10.8879" y2="6.82228"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#003FDB" />
                <stop offset="1" stop-color="#00BCDB" />
              </linearGradient>
              <clipPath id="clip0_1_1390">
                <rect width="127" height="27.3291" fill="white" transform="translate(0 0.670898)" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="forgot-password-box">
            <h4>Esqueceu sua senha?</h4>
            <p>Digite seu email para redefinir sua senha</p>
        </div>
        <form @submit.prevent="forgotPassword">
          <div class="form-group">
            <label for="email">Email </label>
            <input type="email" id="email" v-model="email" placeholder="seu.email@email.com" required />
          </div>
         
          <button type="submit" :disabled="isLoading">
            <span v-if="!isLoading">Redefinir</span>
            <span v-else class="spinner"></span>
          </button>
          <div class="forgot-password">
            <a href="/">Voltar para o login</a>
          </div>
        </form>
        <p v-if="message" class="message" :class="{ success: isSuccess }">{{ message }}</p>
        <p class="powered-by">Videoteca - By Videofront</p>
  
      </div>
      <div class="background-image"></div>
    </div>
  </template>
  
  <script>
  import ApiLogin from '../utils/login'
  
  export default {
    name: 'LoginView',
    data() {
      return {
        email: '',
        password: '',
        message: '',
        isSuccess: false,
        isLoading: false
      }
    },
    computed: {
     
    },
    methods: {   
      async forgotPassword() {
      const payload = {
        email: this.email
      }
      this.isLoading = true
      this.message = ''
      try {
        await ApiLogin.forgotPassword(payload)
        this.isSuccess = true
        this.message = 'Um email foi enviado com as instruções para redefinir sua senha.'
      } catch (error) {
        this.isSuccess = false
        this.message = 'Não foi possível enviar o email. Verifique o endereço informado e tente novamente.'
      } finally {
        this.isLoading = false
      }
    },
   }
  }
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap');
  
  * {
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
.wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100vh;
  justify-content: center;
  min-height: 100vh;
  padding: 0px;
  position: relative;
  overflow: hidden;
  background-color: #ffffff !important;
}
  
  
  
.login-box {
  background: #fff !important;
  padding: 40px;
  border-radius: 22px;
  /* max-width: 450px; */
  width: 30%;
  text-align: center;
  position: relative;
  z-index: 1;
}
  .background-image {
    width: 76%;
    background-image: url('../assets/login-videoteca.png');
    background-size: cover;
    background-position: center;
    height: 100vh;
  }
  .logo-container {
    margin-bottom: 20px;
  }
  
  .login-box h2 {
    margin-bottom: 30px;
    font-size: 26px;
    font-weight: 600;
    color: #2c3e50;
    letter-spacing: -0.5px;
  }
  
  form {
    display: flex;
    flex-direction: column;
  }
  
  .form-group {
    margin-bottom: 20px;
    text-align: left;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #4a5568;
    font-size: 14px;
    letter-spacing: 0.1px;
  }
  
  .form-group input {
    width: 100%;
    padding: 14px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 15px;
    transition: all 0.2s ease;
    color: #2d3748;
    letter-spacing: 0.3px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  }
  
  .form-group input:focus {
    border-color: #4169E1;
    outline: none;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
  }
  
  .forgot-password {
    text-align: right;
    margin-bottom: 20px;
  }
  
  .forgot-password a {
    color: #f5870f;
    text-decoration: none;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.2px;
    transition: color 0.2s ease;
  }
  
  .forgot-password a:hover {
    color: #d67102;
    text-decoration: underline;
  }
  
  button[type="submit"] {
    padding: 14px;
    background: #f5870f;
    border: none;
    border-radius: 6px;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.3px;
    cursor: pointer;
    transition: background 0.3s, transform 0.3s;
    margin-bottom: 20px;
    box-shadow: 0 2px 5px rgba(66, 153, 225, 0.3);
  }
  
  button[type="submit"]:hover {
    background: #d67102;
    transform: translateY(-2px);
  }
  
  .signup-link {
    margin-top: 20px;
    font-size: 14px;
    color: #64748b;
    letter-spacing: 0.2px;
  }
  
  .signup-link a {
    color: #f5870f;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
  }
  
  .signup-link a:hover {
    color: #d67102;
    text-decoration: underline;
  }
  
  .message {
    margin-top: 20px;
    color: #e53e3e;
    font-weight: 500;
    font-size: 13.5px;
    letter-spacing: 0.2px;
    line-height: 1.5;
  }
  
  .message.success {
    color: #38a169;
  }
  
  .powered-by {
    margin-top: 30px;
    font-size: 11px;
    color: #a0aec0;
    text-align: center;
    letter-spacing: 0.5px;
    font-weight: 400;
  }
  
  .spinner {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  
  /* Media query para ajustes específicos, sem interferir no spinner */
  @media (max-width: 480px) {
    .login-box {
      padding: 25px;
      margin: 15px;
    }
    
    .login-box h2 {
      font-size: 24px;
    }
  }
  .forgot-password-box {
    margin: 25px;
    color: #818181;
}
@media (max-width: 600px) {
  .login-box {
    width: 100%;
  }
  .background-image {
   display: none;
  }
}
@media (min-width: 800px) {
  .background-image {
    background-size: 110% auto;
  }
}
</style>